import { render, staticRenderFns } from "./ExpandItem.vue?vue&type=template&id=31377210&"
import script from "./ExpandItem.vue?vue&type=script&lang=js&"
export * from "./ExpandItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports